<div class="reset-password-container">
  <app-mobile-header [title]="'menu.change.password'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

    <app-reset-pass-form [pageName]="pageName" [errorCode]="errorCode" (onSubmitted)="onFormSubmit($event)"></app-reset-pass-form>
</div>
